import LRU from 'onyx-common/lru-cache'

const createCache = ({ cache: opts = {} } = {}) => {
  return new LRU(opts)
}

export default createCache
